module.exports = __webpack_public_path__ + "img/couples_09_V.63c5a08c.webp";